import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  acceptAction,
  removeFriend,
} from '../../../../commons/redux/actions/admin.action'
import TagCustom from '../ServicesDemand/tag'

export default function ItemPartenaireDemand({
  _id,
  name = 'allogho',
  old = 18,
  district = 'nc',
  type='',
  roles = 'Candidat',
  skill = 'electricien',
  some_document = 'public/files/plan-33c4.pdf',
  state_response = 'Attente',
  tel = '04222325',
  town = 'mtz',
  language = 'fr',
}) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const dispatch = useDispatch()
  const [load, setLoad] = useState(false)
  const toast = useToast()
  const cancelRef = React.useRef()
  const remove = async () => {
    try {
      setLoad(true)
      const res = await dispatch(removeFriend(_id))
      if (res.status === 200) {
        toast({
          title: 'Suppression',
          description: `Vous avez supprime cette candidature.`,
          duration: 6000,
          status: 'success',
          isClosable: true,
        })
      }
      setLoad(false)
    } catch (error) {
      console.log(error.message)
    }
  }
  const setTo = async () => {
    try {
      setLoad(true)
      const res = await dispatch(acceptAction(_id))
      onClose()
      if (res.status === 200) {
        toast({
          title: 'Nouveau partenaire',
          description: `Vous avez acceptez ${res.data.name} comme nouveau partenaire`,
          duration: 6000,
          status: 'success',
          isClosable: true,
        })
      }
      setLoad(false)
    } catch (error) {
      setLoad(false)
    }
  }
  return (
    <>
      <div>
        <div className=" border user_itembis p-2   my-3 flex-col">
          <h3 className="text-center font-bold text-sm text-green-500">
            Details du profil
          </h3>

          <div className="flex p-2 flex-wra justify-content-center text-center align-item-center align-content-center">
            <div className="text-xs text-muted p-2 w-50">
              <TagCustom size={'md'} price="Personnalite" colorScheme="blue" />
              <div className="flex-col my-1">
                <h6>Nom :</h6>
                <p className="font-bold text-black">{name}</p>
              </div>
              <div className="flex-col my-1 ">
                <h6>Tel :</h6>
                <p className="font-bold text-black">{tel}</p>
              </div>
              <div className="flex-col my-1 ">
                <h6>Age :</h6>
                <p className="font-bold text-black">{old} ans</p>
              </div>
              <div className="flex-col my-1 ">
                <h6>Sexe :</h6>
                <p className="font-bold text-black">{type?type:'NC'}</p>
              </div>
              <div className="flex-col my-1 ">
                <h6>language :</h6>
                <p className="font-bold text-black">{language}</p>
              </div>
              <div className="flex-col  my-1 ">
                <h6>Competence:</h6>
                <p className="font-bold text-black">{skill}</p>
              </div>{' '}
            </div>{' '}
            <div className="text-xs text-muted p-2 w-50">
              <TagCustom size={'md'} price="Adresse" colorScheme="cyan" />
              <h6>Ville :</h6>
              <p className="font-bold text-black">{town} </p>
              <h6>Quartier :</h6>
              <p className="font-bold text-black">{district} </p>
            </div>
            <div className="text-xs text-muted p-2 w-50">
              <TagCustom size={'md'} price="Media" colorScheme="orange" />
              <h6 className="mt-1 text-xs">Passeport|Cni:</h6>
              <a
                href={`${process.env.REACT_APP_SERVER + some_document}`}
                className="font-bold text-sm text-info"
              >
                passeport || cni
              </a>
            </div>
          </div>
          <div className="flex text-xs justify-content-right align-items-center">
            <h3 className="text-black font-bold">CodeID :</h3>
            <p>{_id}</p>
          </div>
          <div className="flex gap-2 mx-auto justify-content-center">
            <button
              onClick={onOpen}
              className="btn btn-light font-bold bg-gray-200 text-sm btn-sm"
            >
              Accepter{' '}
            </button>
            {load ? (
              <Button
                colorScheme={'red'}
                loadingText="Suppression..."
                isLoading
                className="btn btn-danger font-bold bg-red0 text-white text-sm btn-sm"
              >
                Supprimer
              </Button>
            ) : (
              <button
                onClick={remove}
                className="btn btn-danger font-bold bg-red0 text-white text-sm btn-sm"
              >
                Supprimer
              </button>
            )}
          </div>
        </div>
      </div>
      <>
        <AlertDialog
          motionPreset="slideInBottom"
          leastDestructiveRef={cancelRef}
          onClose={onClose}
          isOpen={isOpen}
          isCentered
        >
          <AlertDialogOverlay />

          <AlertDialogContent>
            <AlertDialogHeader>Confirmer M|Mlle {name} ?</AlertDialogHeader>
            <AlertDialogCloseButton />
            <AlertDialogBody>
              Etes-vous sur de vouloir Accepter ce monsieur comme partenaire ?
            </AlertDialogBody>

            <div className="flex m-3">
              <Button ref={cancelRef} colorScheme={'red'} onClick={onClose}>
                Annuler
              </Button>
              {load ? (
                <Button
                  colorScheme="green"
                  isLoading
                  loadingText="Patientez..."
                  onClick={setTo}
                  ml={3}
                ></Button>
              ) : (
                <Button colorScheme="green" onClick={setTo} ml={3}>
                  Confirmer
                </Button>
              )}
            </div>
          </AlertDialogContent>
        </AlertDialog>
      </>
    </>
  )
}
